<template>
  <v-container id="userview">
    <v-card max-width="800px">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
        <v-text-field
            v-model="model.displayName"
            :label="$t('users.name')"
            required
            :rules="[rules.required]"
          />
        <v-text-field
            v-model="model.email"
            :label="$t('users.email')"
            :rules="[rules.emailRules]"
            :disabled="model.authID !== undefined"
            required
          />
          <v-combobox
            v-model="model.roles"
            :label="$t('users.roles')"
            required
            :rules="[rules.roleRules]"
            multiple
            chips
            :items="assignableRoles"
          />
          <v-text-field
            v-model="model.tag"
            :label="$t('users.tag')"
          />
         <!-- <v-select
            v-if="model.roles.includes('learner')"
            v-model="model.content"
            :items="contentSelectionLocalised"
            item-text="title"
            item-value="uid"
            multiple
            :label="$t('users.restrict-content-to')"
          > 
           <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllContent">
                <v-list-item-action>
                  <v-icon :color="model.content && model.content.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('users.select-all') }}
</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>-->

          <v-text-field
            v-if="invited"
            v-model="registrationLink"
            :label="$t('users.registration-link')"
            readonly
            hint="Share this link with user if Bodyswaps emails are blocked"
          />
</v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          @click="cancel"
        >
          {{ $t('global.cancel') }}
</v-btn>
        <v-btn
          :disabled="!valid"
          color="success"
          @click="validate"
        >
          {{ $t('global.save') }}
</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import { Users, Roles } from '@/helpers/users.js'
  import { getRegionParam } from '@/helpers/shared'

  export default {
    name: 'UserView',

    props: {
      model: { type: Object, required: true, default: undefined },
      contentSelection: { type: Array, required: true, default: undefined },
      roles: { type: Array, required: false, default: undefined },
    },

    data () {
      return {
        testContent: undefined,
        valid: false,
        loading: true,
        displayName: '',
        rules: {
          required: value => !!value || this.$t('global.required'),
          roleRules: value => !!value || this.$t('users.requires-one-role'),
          emailRules: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('users.invalid-e-mail')
          },
        },
      }
    },

    computed: {
      contentSelectionLocalised () {
        const i = this.contentSelection.map((x) => {
          return { uid: x.uid, title: x.locales[this.$i18n.locale]?.title ?? x.locales.en?.title ?? x.uid } // x.title: this.$t('modules.' + x.uid) }
        })
        return i
      },
      invited () {
        return this.model.status === 'invited'
      },
      registrationLink () {
        const returnURL = process.env.VUE_APP_URL + '/register'
        const displayName = this.model.displayName.replace(/ /g, '-')
        const regionParam = getRegionParam('&')
        return `${returnURL}?resetCode=${this.model.resetCode}&displayName=${displayName}&email=${this.model.email}${regionParam}`
      },
      assignableRoles () {
        if (this.roles) {
          return this.roles
        }
        // get your max role
        const maxRole = Roles.All.reduce((prev, current) => (this.$store.getters.currentUserProfile.user.roles.includes(current) ? current : prev))
        // find index in roles
        let maxRoleIndex = Roles.All.indexOf(maxRole)
        if (maxRole === 'admin') {
          // admins can create admins
          maxRoleIndex++
        }
        return Roles.All.slice(0, maxRoleIndex)
        // filter off ones above
      },
      title: function () {
        const verb = this.model.id === undefined ? this.$t('users.create') : this.$t('global.edit')
        const noun = this.role ? this.role : this.$t('users.user')
        return verb + ' ' + noun
      },
      likesAllContent () {
        return this.model.content && this.model.content.length === this.contentSelection.length
      },
      likesSomeContent () {
        return this.model.content && this.model.content.length > 0 && !this.likesAllContent
      },
      icon () {
        if (this.likesAllContent) return 'mdi-close-box'
        if (this.likesSomeContent) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    },

    methods: {
      async validate () {
        Users.SetDirty()
        this.$emit('save')
      },
      cancel () {
        this.$emit('cancel')
      },
      toggleAllContent () {
        // console.log(JSON.stringify(this.contentSelection))
        this.$nextTick(() => {
          if (this.likesAllContent) {
            this.model.content = []
          } else {
            this.model.content = this.contentSelection.map(x => x.uid)
          }
        })
      },
    },
  }
</script>

<style scoped>
  .status {
    padding: 5px 10px;
    border-radius: 5px;
    width: 150px;
    text-align: center;
  }
  .inviteSent { background-color: grey; color: white; }
  .awaitingSubmission { background-color: orange; color: white; }
  .submitted { background-color: red; color: white; }
  .reviewed { background-color: green; color: white; }
</style>
